<template>
  <div class="dataList">
    <!-- <div class="reply" ref="replayModal">
      <a-modal
        v-model:visible="addVisible"
        :title="title"
        @ok="handleOk"
        :getContainer="() => $refs.replayModal"
        width="60%"
        :afterClose="afterClose"
        wrapClassName="add-modal"
      >
        <a-form ref="formRef" :model="formState" :rules="rules">
        </a-form>
        <a-transfer
                :data-source="mockData"
                show-search
                 :filter-option="(inputValue, item) => item.title.toLowerCase().indexOf(inputValue.toLowerCase()) !== -1"
                :target-keys="targetKeys"
                :render="item => item.title"
                @change="handleChange"
            >
          <template
            #children="{
            direction,
            filteredItems,
            selectedKeys,
            onItemSelectAll,
            onItemSelect,
            }"
        >
        <a-table
        :row-selection="getRowSelection({  selectedKeys, onItemSelectAll, onItemSelect })"
          :columns="direction === 'left' ? leftColumns : rightColumns"
        :data-source="filteredItems"
           size="small"
        >
            <a-pagination :total="50" show-less-items />
        </a-table>
      </template>
            </a-transfer>
        <a-form-item label="包含平台" name="keyEmail">
          <a-checkbox-group
            v-model:value="formState.iaInfoId"
            :options="platList"
            :value="['Pear']"
          />
        </a-form-item>
        <a-form-item name="followPoint">
          <template #label>
            变化百分比
            <a-tooltip>
              <template #title>
                若目标关键词的变化率绝对值超过对应百分比值（无论上升还是下降），均会触发预警邮件
              </template>
              <QuestionCircleOutlined class="middle" />
            </a-tooltip>
          </template>
          <a-input-number placeholder="请填写变化百分比" v-model:value="formState.followPoint" />%
        </a-form-item>
        <div
          class="seting"
          style="border-bottom: 2px solid #aaa; width: 100%; text-align: left; font-size: 20px"
        >
          接收邮箱
        </div>
        <a-form layout="inline" class="form-class">
          <a-form-item class="form-margin"> </a-form-item>
          <a-table
            :pagination="false"
            bordered
            :data-source="dataEmailSource"
            :columns="emailColumns"
          >
            <template #email="{ text, record }">
              <div class="editable-cell">
                <div v-if="editableData[record.key]" class="editable-cell-input-wrapper">
                  <a-input
                    v-if="editableData[record.key]"
                    placeholder="请输入邮箱"
                    @pressEnter="save(record.key)"
                    v-model:value="editableData[record.key]['email']"
                    style="margin: -5px 0"
                  />
                  <template v-else>
                    {{ text }}
                  </template>
                </div>
                <div v-else class="editable-cell-text-wrapper">
                  {{ text || ' ' }}
                </div>
              </div>
            </template>
            <template #operation="{ record }">
              <div class="editable-row-operations">
                <span> </span>
                <span v-if="editableData[record.key]">
                  <a @click="save(record.key)">保存</a>
                  <a @click="cancel(record.key)" style="margin: 0px 5px">取消</a>
                </span>
                <span v-else>
                  <a @click="edit(record.key)">编辑</a>
                </span>
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确定删除?"
                  @confirm="onDelete(record.key)"
                >
                  <a v-if="!editableData[record.key]" style="margin: 0px 5px">删除</a>
                </a-popconfirm>
              </div>
            </template>
          </a-table>
          <a-button class="editable-add-btn" @click="handleAdd" style="margin-bottom: 8px"
            >+新增收件人</a-button
          >
        </a-form>
      </a-modal>
    </div> -->
    <a-layout id="components-layout-demo-top" class="layout">
      <headerComponent :showNormal="true"></headerComponent>
      <a-layout-content>
        <a-breadcrumb class="bgCrumb">
          <a-breadcrumb-item @click="turnHome">首页</a-breadcrumb-item>
          <a-breadcrumb-item class="two">提醒管理</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="tip">提醒管理</div>
        <div class="dataContent">
          <a-form :model="formData" layout="inline" class="form-class">
            <div class="row1">
              <a-input
                v-model:value="formData.name"
                @pressEnter="search"
                placeholder='请输入"预警词"'
                style="width: 260px"
              >
                <template #suffix>
                  <SearchOutlined @click="search" />
                </template>
              </a-input>
              <a-button @click="add" type="primary" class="dban" style="margin-left: 20px">
                + 新建
              </a-button>
            </div>
            <a-table
              bordered
              :row-key="(record) => record.id"
              :dataSource="dataSource"
              :columns="columns"
              :pagination="false"
            >
              <template #setIndex="{ index }">
                {{ index + 1 }}
              </template>
              <!-- <template #followPoint="{ text }"> {{ text }}% </template> -->
              <!-- <template #iaInfoId="{ text }">
                <span v-for="list in platList">
                  <span v-if="text.indexOf(list.id) != -1"> {{ list.label }}, </span>
                </span>
              </template> -->
              <template #operation="{ record }">
                <a class="edit" @click="showModal(record.id)">编辑</a>
                &nbsp; &nbsp;
                <a-popconfirm
                  v-if="dataSource.length"
                  title="确认删除该提醒？"
                  @confirm="onDelete1(record.id)"
                  cancelText="取消"
                  okText="确认"
                >
                  <a class="del">删除</a>
                </a-popconfirm>
              </template>
            </a-table>
            <a-pagination
              show-size-changer
              show-quick-jumper
              v-model:current="current"
              v-model:pageSize="pageSize"
              @change="changeData"
              :page-size-options="pageSizeOptions"
              @showSizeChange="onShowSizeChange"
              :total="total"
            />
          </a-form>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center"> </a-layout-footer>
    </a-layout>
      <div class="hoverBottomWapper"> 
      <div class="hoverBottom1">
        <a  style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../../assets/beian.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a href="http://www.beian.gov.cn/" target="_blank">粤公网安备 44011202001572号</a> | <a href="https://beian.miit.gov.cn" target="_blank" >粤ICP备2021056281号</a> </p ></a>
    </div>
    </div>
  </div>
</template>
<script>
import { message, Modal } from 'ant-design-vue'
import { difference } from 'lodash-es';
import { SettingOutlined, SearchOutlined, QuestionCircleOutlined } from '@ant-design/icons-vue'
import { getHotNotcieList, getHotList, delHotNotcieList, getAllWordList, addNotice, getNoticeDetail, editNotice } from "../../utils/api"
import headerComponent from '../../components/hotHeader'
import '../../lib/rem.js'
import { cloneDeep } from "lodash-es"
let localDataSource = []
const checkAge = function (rule, val) {
  if (/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(val)) {
    return Promise.resolve()
  } else {
    return Promise.reject('邮箱格式不正确')
  }
}
export default {
  data () {
    return {
      leftColumns:[{
          dataIndex: 'title',
          title: '关键词',
      }],
      rightColumns:[{
          dataIndex: 'title',
          title: '关键词',
      }],
      pageSizeOptions: ['10', '20', '50', '100'],
      formState: {
        followPoint: '',
        iaInfoId: '',
        keywords: '',
        receiveEmail: ''
      },
      editableData: {},
      emailColumns: [
        {
          title: "序号",
          dataIndex: "name",
          key: 'name',
          width: "30%",
          slots: {
            customRender: "name",
          },
        },
        {
          title: "邮箱",
          dataIndex: "email",
          key: 'email',
          slots: {
            customRender: "email",
          },
        },
        {
          title: "操作",
          dataIndex: "operation",
          slots: {
            customRender: "operation",
          },
        },
      ],
      dataEmailSource: [{
        name: 1,
        key: 1,
        email: "",
      }],
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { validator: checkAge, message: '邮箱格式不正确', trigger: 'blur' },
        ]
      },
      mockData: [],
      defaultData: [],
      addVisible: false,
      isChecked1: false,
      isChecked2: false,
      isChecked3: true,
      isChecked4: true,
      columns: [
        {
          title: "No.",
          dataIndex: "setIndex",
          key: "setIndex",
          isCheck: true,
          slots: {
            customRender: "setIndex",
          },
        },
        {
          title: "提醒名称",
          dataIndex: "name",
           align: "right",
          sorter: (a, b) => a.name.localeCompare(b.name),
          key: "name",
          isCheck: true,
        },
        {
          title: "预警词",
          dataIndex: "keywords",
           align: "right",
          sorter: (a, b) => a.keywords.localeCompare(b.keywords),
          key: "keywords",
          isCheck: true,
        },
        {
          title: "所选热榜",
          dataIndex: "followPoint",
          align: "right",
          width:"40%",
          sorter: (a, b) => a.followPoint.localeCompare(b.followPoint),
          key: "followPoint",
          slots: { customRender: 'followPoint' },
          isCheck: true
        },
        {
          title: "接受邮箱",
          align: "right",
           width:"15%",
          sorter: (a, b) => Number(a.receiveEmail) - Number(b.receiveEmail),
          dataIndex: "receiveEmail",
          key: "receiveEmail",
          isCheck: true
        },
        {
          title: "操作",
          align: "right",
          dataIndex: "operation",
          slots: {
            customRender: "operation",
          },
        },
      ],
      id: "",
      editType: 0,
      title: '添加提醒',
      current: 1,
      dataSource: [],
      platList: [],
      targetKeys: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      mockData: [],
      formData: {
        name: ""
      }
    }
  },
  components: {
    SettingOutlined,
    headerComponent,
    SearchOutlined,
    QuestionCircleOutlined
  },
  methods: {
        getRowSelection({ selectedKeys, onItemSelectAll, onItemSelect }) {
      return {
        // getCheckboxProps: item => ({ props: { disabled: disabled || item.disabled } }),
        onSelectAll(selected, selectedRows) {
          const treeSelectedKeys = selectedRows
            .map(({ key }) => key);
          const diffKeys = selected
            ? difference(treeSelectedKeys, selectedKeys)
            : difference(selectedKeys, treeSelectedKeys);
          onItemSelectAll(diffKeys, selected);
        },
        onSelect({ key }, selected) {
          onItemSelect(key, selected);
        },
        selectedRowKeys: selectedKeys,
      }},
     handleSearch(dir, val){
      let that = this;
      if(dir=="left"){
        that.mockData = []
        if(val==''){
          that.mockData = that.defaultData
          return
        }
        getAllWordList(val.toLowerCase()).then(res=>{
          res.rows.map((cur,index)=>{
            that.mockData.push({
                key: index,
                title: cur.keyword,
                chosen: false,
              })
          })
        })
      }
    },
    filterOption(input, option) {
        return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    formatNum (n) {
      let num = n.toString()
      let decimals = ''
      // 判断是否有小数
      num.indexOf('.') > -1 ? decimals = num.split('.')[1] : decimals
      let len = num.length
      if (len <= 3) {
        return num
      } else {
        let temp = ''
        let remainder = len % 3
        decimals ? temp = '.' + decimals : temp
        if (remainder > 0) { // 不是3的整数倍
          return num.slice(0, remainder) + ',' + num.slice(remainder, len).match(/\d{3}/g).join(',') + temp
        } else { // 是3的整数倍
          return num.slice(0, len).match(/\d{3}/g).join(',') + temp
        }
      }
    },
    turnHome () {
      this.$router.push('hotWord')
    },
    afterClose () {
      this.targetKeys = []
      this.mockData = this.defaultData
      this.editableData = {}
      this.editableData[1] = {
        name: `${1}`,
        key: `${1}`,
        email: ``,
      }
      this.formState = {
        followPoint: '',
        iaInfoId: '',
        keywords: '',
        receiveEmail: ''
      }
    },
    async getIndex () {
      let that = this
      await getAllWordList().then(res => {
        if (res.total != 0) {
          // that.hotWord = res.rows
          res.rows.map((cur, index) => {
            that.mockData.push({
              key: index,
              title: cur.keyword,
              chosen: false
            })
          })
          that.defaultData = that.mockData
          console.log(that.mockData)
        } else {
        }
      })
    },
    handleOk () {
      let that = this
      if (that.targetKeys.length == 0) {
        message.error('请选择关键词')
        return
      }
      if (that.targetKeys.length > 5) {
        message.error('最多选择5个关键词')
        return
      }
      if (that.formState.iaInfoId == '') {
        message.error('请选择平台')
        return
      }
      if (that.formState.followPoint == '') {
        message.error('请输入变化百分比')
        return
      }
      let dataStr = ''
      let canSubmit = true
      let reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$") //正则表达式
      this.dataEmailSource.map((cur, index) => {
        if (!reg.test(cur.email)) {
          canSubmit = false
        }
        dataStr = dataStr + ',' + cur.email
      })
      dataStr = dataStr.substring(1, dataStr.length)
      that.formState.iaInfoId = that.formState.iaInfoId.toString()
      if (this.dataEmailSource.length == 0) {
        message.info('接收邮箱未填写')
        return
      }
      if (!canSubmit) {
        message.info('接收邮箱格式不正确')
        return
      }
      let str1 = ''
      that.targetKeys.map((cur) => {
        str1 = str1 + that.mockData[cur].title + ','
      })
      str1 = str1.substring(0, str1.length - 1)
      that.formState.keywords = str1
      that.formState.receiveEmail = dataStr
      if (that.editType === 0) {
        addNotice(that.formState).then(res => {
          that.addVisible = false
          that.getData()
          message.info('添加成功')
        })
      } else {
        that.formState.id = that.id
        editNotice(that.formState).then(res => {
          that.addVisible = false
          that.getData()
          message.info('修改成功')
        })
      }

    },
    reset () {
      this.columns = this.columns1
      this.isChecked1 = false
      this.isChecked2 = false
    },
    confirm () {
      this.old1Colmns = []
      if (!this.isChecked1) {
        this.oldColumns[5].isCheck = false
      } else {
        this.oldColumns[5].isCheck = true
      }
      if (!this.isChecked2) {
        this.oldColumns[6].isCheck = false
      } else {
        this.oldColumns[6].isCheck = true
      }
      // if(!this.isChecked3){
      //    this.oldColumns[3].isCheck = false;
      //  }else{
      //    this.oldColumns[3].isCheck = true;
      //  }
      // if(!this.isChecked4){
      //    this.oldColumns[2].isCheck = false;
      //  }else{
      //    this.oldColumns[2].isCheck = true;
      //  }
      //  console.log(this.columns)
      let that = this
      that.oldColumns.map((cur, index) => {
        if (cur.isCheck) {
          that.old1Colmns.push(that.oldColumns[index])
        }
      })
      that.columns = that.old1Colmns
    },
    search () {
      this.getData()
    },
    down (id, val) {
      let that = this
      if (val == '0') {
        Modal.confirm({
          title: '确定启用组合么?',
          onOk () {
            changeStatus({ id: id, status: val }).then(res => {
              message.success('启用成功')
              that.getData()
            })
          },
          onCancel () {
          },
        })

      } else {
        Modal.confirm({
          title: '确定暂停组合么?',
          onOk () {
            changeStatus({ id: id, status: val }).then(res => {
              message.success('暂停成功')
              that.getData()
            })
          },
          onCancel () {
          },
        })
      }

    },
    onDelete1 (id) {
      delHotNotcieList(id).then(res => {
        message.info('删除成功')
        this.getData()
      })
    },
    add () {
      // this.addVisible = true
      // this.editType = 0
      // this.title = '添加提醒'
      this.$router.push('addHotDataList')
    },
    changeData (pageNo, pageSize) {
      this.pageNo = pageNo
      this.pageSize = pageSize
      this.getData()
    },
    onShowSizeChange (pageNo, pageSize) {
      this.pageNo = pageNo
      this.pageSize = pageSize
      this.getData()
    },
    formatEmail(val){
      let a = ''
      val.map((cur)=>{
        a = a + cur.receiveEmail+','
      })
      a = a.substring(0,a.length-1)
      return a
    },
    showModal (id) {
        this.$router.push({
          path:'editHotDataList',
          query:{
            id:id
          }
        })      
    },
    initPlat(val){
      let a = ''
      this.platList.map(cur=>{
        val.map((_cur)=>{
          if(cur.id==_cur){
            a = a + cur.label+','
          }
        })
      })
      return a.substring(0,a.length-1)
    },
    getData () {
      let that = this
      this.dataSource = []
      getHotNotcieList({ pageNo: this.pageNo, pageSize: this.pageSize, keywords: this.formData.name }).then(res => {
        if (res.total != 0) {
          res.rows.map((cur, index, arr) => {
            this.dataSource.push({
              createTime: cur.createTime,
              followPoint: that.initPlat(cur.topInfoId),
              id: cur.id,
              name:cur.name,
              keywords: cur.keywords,
              receiveEmail: that.formatEmail(cur.topNotifyParams),
              userId: cur.userId,
            })
          })
        } else {
          this.dataSource = []
        }
        this.total = res.total
        // if(res.total>=20){
        //   this.showBtn = false
        // }else{
        //   this.showBtn = true
        // }
        // this.pagination = {
        //   total: 10
        // }
      })
    },
    handleChange (key, val) {
      if (key.length > 5) {
        message.info('最多选择5个关键词')
        return
      }
      this.targetKeys = key.sort()
    },
    getPlat () {
      getHotList().then(res => {
        res.rows.map((cur) => {
          this.platList.push({
            id: cur.id,
            label: cur.name,
            value: cur.id
          })
        })
        this.getData()
      })
    },
    handleAdd () {
      let that = this
      const count = this.dataEmailSource.length + 1
      const newData = {
        name: `${count}`,
        key: `${count}`,
        email: ``,
      }
      this.dataEmailSource.push(newData)
      this.editableData[count] = {
        name: `${count}`,
        key: `${count}`,
        email: ``,
      }
    },
    cancel (key) {
      delete this.editableData[key]
    },
    onDelete (key) {
      this.dataEmailSource = this.dataEmailSource.filter((item) => item.key !== key)
    },
    save (key) {
      let that = this
      if (that.editableData[key].email == '') {
        message.error('请输入邮箱')
        return
      }

      if (!(/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(that.editableData[key].email))) {
        message.error('邮箱格式不正确')
        return
      }
      let find = false
      let arr = that.dataEmailSource
      for (let i = 0;i < arr.length;i++) {
        // for (var j = i + 1; j < arr.length; j++) {
        if (arr[i].email == that.editableData[key].email) { find = true; break }
        // }
        if (find) break
      }
      if (find) {
        message.error('该邮箱已添加')
        return
      }
      Object.assign(
        that.dataEmailSource.filter((item) => key === item.key)[0],
        that.editableData[key]
      )
      delete that.editableData[key]
      // })
      // .catch((error) => {
      //   console.log('error', error);
      // });
    },
    edit (key) {
      let that = this
      this.editableData[key] = cloneDeep(
        that.dataEmailSource.filter((item) => key === item.key)[0]
      )
    },
  },
  mounted () {
    this.getPlat()
  }
}

</script>

<style lang="scss" scoped>
@import '../../assets/common/modal.scss';
.add-modal {
  .editable-add-btn {
    width: 100%;
    border-style: dashed;
  }
  .ant-input-number {
    width: 150px;
  }
  .middle {
    vertical-align: middle;
  }
}
.dataList {
  font-family: 'NotoSansSC', sans-serif;
  display: flex;
  width: 100vw;
  min-height: 100vh;
  flex-direction: column;
    .hoverBottomWapper{
    width: 100%;
    background-color: #333;
    padding-bottom: 10px;
    .hoverBottom1{
      position: relative;
      width:100%;
      // text-align:center;
      //  padding:0px 0 10px 0;
      width:fit-content;
      margin: 0 auto;
      display: block;
      text-align:center;
       p>a{
          color: rgb(147, 147, 147);
           position: relative;
          padding-bottom: 5px;
          &::after{
              content: "";
              display: block;
              height: auto;
              border-bottom: 0!important;
              background-image: linear-gradient(#00f000,#00f000);
              text-decoration: none;
              padding-bottom: 2px;
              background-position: 0 100%;
              background-repeat: no-repeat;
              background-size: 0 2px;
              transition: background-size .3s;
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
          }
          &:hover{
              color: #00F000;
              // border-bottom: 1px solid #00F000;
              // background-size: 100% 2px
              &::after{
                  background-size: 100% 2px
              }
          }
        }
    }
  }
  /deep/.ant-input-affix-wrapper-focused{
       border-bottom: 2px solid #00f000;
  }
  
  .edit {
    color: #333;
  }
  .del {
    color: #333;
  }
  /deep/.ant-layout-footer {
    background-color: #333;
  }
  /deep/.ant-table-thead > tr > th {
    font-weight: bold;
  }
  /deep/.ant-breadcrumb-link {
    cursor: pointer;
  }
  /deep/.ant-layout-footer {
    background: #333333;
  }
  /deep/.ant-layout-content {
    position: relative;
    background: #333333;
    .tip {
      position: absolute;
      top: 95px;
      left: 152px;
      font-size: 32px;
      color: #fff;
    }
  }
  .dataContent {
    background: #fff;
    // padding: 24px;
    padding-bottom: 24px;
    min-height: 280px;
    width: 84.2%;
    margin: 0 auto;
    .row1 {
      text-align: right;
      padding: 20px 0 20px 0;
      background-color: #000;
      display: inline-block;
    }
    .dban {
      margin-right: 40px;
      background-color: #00f000;
      border-color: #00f000;
      color: #333;
    }
    /deep/.ant-table-wrapper {
      padding: 24px 24px;
    }
    /deep/.ant-table-bordered .ant-table-tbody > tr > td {
      border-color: #d9d9d9;
      border-right: 1px solid #d9d9d9;
    }
    /deep/.ant-table-thead th {
      background-color: #000;
      border: 1px solid #d9d9d9 !important;
      color: #fff;
      &:hover {
        background-color: #000;
      }
    }
  }
  /deep/.bgCrumb {
    padding: 40px 116px 67px 152px;
    margin-bottom: 60px;
    font-size: 24px;
    height: 200px;
    font-weight: bold;
    font-family: 'Microsoft Tai Le Bold', 'Microsoft Tai Le', sans-serif;
    background-color: #fff;
    background-image: url('../../assets/image/dd.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: 0 0px;
    color: #fff;
  }
  .two {
    /deep/.ant-breadcrumb-link {
      color: #fff;
        cursor: default;
    }
  }
  /deep/.ant-breadcrumb-link {
    color: #999999;
    font-size: 14px;
  }
  /deep/.ant-breadcrumb-separator {
    color: #999999;
    font-size: 14px;
  }

  .ant-pagination {
    margin-top: 30px;
    text-align: right;
  }

  .form-class {
    display: flex;
    flex-direction: column;
  }
}
</style>